import { useCallback, useEffect } from 'react';
import { findClosestYear } from '@yakit/ui-components';

import { getYears } from '@VDL/api';
import { useVDLStore } from '@VDL/store/VDLstore';

import type { IYear } from '@VDL/api/types/IYear';
import { isAxiosError } from 'axios';

export const useFetchYearsData = () => {
  const { setSelectedYear, setYearList } = useVDLStore();

  const handleSetSelectedYear = useCallback(
    (yearList: IYear[]) => {
      const yearsNumberList = yearList.map((item) => +item.code);
      const target = new Date().getFullYear();
      const closestYear = findClosestYear(yearsNumberList, target);

      setSelectedYear(closestYear);
    },
    [setSelectedYear]
  );

  const fetchData = useCallback(async () => {
    try {
      const response = await getYears();
      const yearsData = response.data;

      setYearList(yearsData);
      handleSetSelectedYear(yearsData);
    } catch (error) {
      if (isAxiosError(error)) console.log(error.message);
      else console.log(error);
    }
  }, [setYearList, handleSetSelectedYear]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
};
